/* =========================================
   FunkPrint Design Studio — frontend
   ========================================= */
(function() {
  'use strict';

  const state = {
    vibe: null,
    theme: null,
    twist: '',
    variants: [],
    selectedVariantUrl: null,
    selectedProduct: null,
    selectedProductPrice: null
  };

  const webhookUrl = window.FunkPrint?.designStudioWebhook
                     || 'https://YOUR_N8N_INSTANCE.app.n8n.cloud/webhook/funkprint-design-studio';

  // Step navigation
  function goToStep(n) {
    document.querySelectorAll('[data-step-content]').forEach(el => {
      el.classList.toggle('hidden', el.dataset.stepContent !== String(n));
    });
    document.querySelectorAll('.step-pill').forEach(p => {
      const pn = parseInt(p.dataset.step);
      p.classList.toggle('is-active', pn === n);
      p.classList.toggle('is-done', pn < n);
    });
    window.scrollTo({ top: document.querySelector('.studio__header').offsetTop - 20, behavior: 'smooth' });
  }

  // Choice tile selection
  document.querySelectorAll('[data-field]').forEach(group => {
    const field = group.dataset.field;
    const tiles = group.querySelectorAll('.choice-tile');
    tiles.forEach(tile => {
      tile.addEventListener('click', () => {
        if (group.tagName === 'TEXTAREA') return;
        tiles.forEach(t => t.classList.toggle('is-selected', t === tile));
        if (field === 'product') {
          state.selectedProduct = tile.dataset.value;
          state.selectedProductPrice = parseInt(tile.dataset.price);
          document.querySelector('[data-action="add-to-cart"]').disabled = false;
        } else {
          state[field] = tile.dataset.value;
        }
      });
    });
  });

  // Twist textarea
  document.querySelector('[data-field="twist"]')?.addEventListener('input', (e) => {
    state.twist = e.target.value;
  });

  // Next/back buttons
  document.querySelectorAll('[data-next]').forEach(btn => {
    btn.addEventListener('click', () => {
      const next = parseInt(btn.dataset.next);
      if (next === 2 && !state.vibe) {
        alert('Pick a vibe first.');
        return;
      }
      if (next === 3 && !state.theme) {
        alert('Pick a theme or hit "Custom".');
        return;
      }
      goToStep(next);
    });
  });

  document.querySelectorAll('[data-prev]').forEach(btn => {
    btn.addEventListener('click', () => goToStep(parseInt(btn.dataset.prev)));
  });

  // Generate variants
  document.querySelector('[data-action="generate"]')?.addEventListener('click', async () => {
    if (!state.twist.trim() || state.twist.trim().length < 5) {
      alert('Add a few more words to your twist — at least 5 characters.');
      return;
    }
    goToStep(4);
    try {
      const response = await fetch(webhookUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          vibe: state.vibe,
          theme: state.theme,
          twist: state.twist
        })
      });
      if (!response.ok) throw new Error('Generation failed: ' + response.status);
      const data = await response.json();
      // Expected response shape: { variants: [{url: '...'}, ...] }
      if (!data.variants || data.variants.length === 0) {
        throw new Error('No variants returned');
      }
      state.variants = data.variants;
      renderVariants(data.variants);
      goToStep(5);
    } catch (err) {
      console.error(err);
      const status = document.getElementById('loading-status');
      if (status) {
        status.textContent = 'Something went wrong. Please try again.';
        status.style.color = 'var(--funk-street)';
      }
      setTimeout(() => goToStep(3), 2400);
    }
  });

  // Render variants
  function renderVariants(variants) {
    const grid = document.getElementById('variants-grid');
    if (!grid) return;
    grid.innerHTML = '';
    variants.forEach((v, i) => {
      const tile = document.createElement('div');
      tile.className = 'result-tile';
      tile.innerHTML = `<img src="${v.url}" alt="Variant ${i+1}" loading="lazy">`;
      tile.addEventListener('click', () => {
        document.querySelectorAll('.result-tile').forEach(t => t.classList.remove('is-selected'));
        tile.classList.add('is-selected');
        state.selectedVariantUrl = v.url;
        document.querySelector('[data-action="apply"]').disabled = false;
      });
      grid.appendChild(tile);
    });
  }

  // Regenerate
  document.querySelector('[data-action="regenerate"]')?.addEventListener('click', () => {
    document.querySelector('[data-action="generate"]').click();
  });

  // Apply variant -> go to product picker
  document.querySelector('[data-action="apply"]')?.addEventListener('click', () => {
    if (!state.selectedVariantUrl) { alert('Pick a variant first.'); return; }
    goToStep(6);
  });

  // Add to cart
  document.querySelector('[data-action="add-to-cart"]')?.addEventListener('click', async () => {
    if (!state.selectedProduct || !state.selectedVariantUrl) {
      alert('Pick a product and a design variant.');
      return;
    }

    // For Phase 1: redirect to a Shopify product with the design URL as a line-item property
    // The product handles need to exist in Shopify with these handles:
    const productHandleMap = {
      'classic-tee': 'custom-classic-tee',
      'oversized-tee': 'custom-oversized-tee',
      'hoodie': 'custom-hoodie',
      'sweatshirt': 'custom-sweatshirt',
      'mug': 'custom-mug',
      'cap': 'custom-cap'
    };
    const handle = productHandleMap[state.selectedProduct];
    const productUrl = `/products/${handle}?design_url=${encodeURIComponent(state.selectedVariantUrl)}&design_vibe=${state.vibe}&design_theme=${state.theme}`;
    window.location.href = productUrl;
  });
})();
